import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import AppFieldBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { NumberBox, SelectBox, TextArea } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';
import $createStore from 'utils/create-store-instance';
import { rtkCallback } from 'utils/rtkCallback';

import { MaterialItem } from 'bus/material/types';
import { useGetMethodOfReceptionListQuery } from 'bus/methodOfReception/services';
import {
  useChangeRequestWorkMutation,
  useCreateRequestWorkMutation,
  useGetRequestQuery,
  useLazyGetRequestWorkQuery,
} from 'bus/request';
import { CreateWorkRequest } from 'bus/request/types';

import './AdjustmentCreateWorkRequestModal.sass';

const initialForm: CreateWorkRequest = {
  id: null,
  transportId: null,
  driverId: null,
  quantity: undefined,
  printQuantity: undefined,
  methodOfReceptionId: undefined,
  comment: '',
};

type Props = {
  id: number | null;
  requestId: number;
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
};

const AdjustmentCreateWorkRequestModal: FC<Props> = (props) => {
  let { id } = useParams<{ id: string }>();
  const [materials, setMaterial] = useState<MaterialItem[]>([]);

  const [stateAdjustment, setStateAdjustment] = useState<Record<string, number>>({});

  const storeTransport: any = useMemo(() => {
    const defaultFilter = ['id', '>', '0'];
    return $createDataSource<CreateWorkRequest>('/v1/Transport', 'id', { defaultFilter });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  const { data: requestData } = useGetRequestQuery({ id: props.requestId });

  const [getRequestWork] = useLazyGetRequestWorkQuery();
  const { data: methodOfReceptionList } = useGetMethodOfReceptionListQuery({ requestId: id });
  const [createRequestWork, { isLoading: isLoadingCreate, reset: resetCreate }] = useCreateRequestWorkMutation();
  const [changeRequestWork, { isLoading: isLoadingChange, reset: resetChange }] = useChangeRequestWorkMutation();

  const disabledSubmit = isLoadingChange || isLoadingCreate;

  const storeEmployee: any = useMemo(() => {
    const defaultFilter = [['postId', '>=', 1], 'and', ['postId', '<=', 2]];
    return $createDataSource('/v1/employee', 'id', { defaultFilter });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id]);

  const [form, setForm] = useState<CreateWorkRequest>({
    ...initialForm,
    comment: requestData?.comment || '',
  });

  let formSubmit = useRef<Form>(null);
  let validateRef = useRef<ValidationGroup>(null);

  const requestDateSource = useCallback(() => {
    return $createStore('/v1/Material?onlyInRecipe=true', 'id')
      .load()
      .then((res: any) => {
        const data = {};
        for (let item of res as MaterialItem[]) {
          data[item.id!] = 0;
        }

        setStateAdjustment(data);
        setMaterial(res);
      });
  }, []);

  useEffect(() => {
    requestDateSource();
  }, [requestDateSource]);

  const fetchSuccess = () => {
    props.refresh();
    props.changeVisible(false);
    resetCreate();
    resetChange();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    const requestData = {
      ...form,
      type: 2,
      adjustmentRecipes: Object.keys(stateAdjustment).map((key) => ({
        materialId: key,
        quantity: stateAdjustment[key],
      })),
    };

    if (validateRef.current?.instance.validate().isValid) {
      if (props.id) {
        changeRequestWork(requestData).then((r) => rtkCallback(r, fetchSuccess));
      } else {
        createRequestWork(requestData).then((r) => rtkCallback(r, fetchSuccess));
      }
    }
  };

  const onShown = async () => {
    validateRef.current?.instance.reset();

    if (props.id) {
      setForm((prev) => ({ ...prev, id: props.id, comment: requestData?.comment || '' }));
      const result = await getRequestWork({ id: props.id });
      setForm(result.data!);

      const materialsValue = {};
      for (let item of result.data?.adjustmentRecipes!) {
        materialsValue[item.materialId!] = item.quantity;
      }

      setStateAdjustment(materialsValue);
    } else {
      setForm((prev) => ({ ...prev, id: +id, comment: requestData?.comment || '' }));
    }
  };

  const onHiden = () => {
    setForm(initialForm);
    setStateAdjustment({});
    validateRef.current?.instance.reset();
  };

  const onChangesChange = (key, value) => {
    setStateAdjustment((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  return (
    <div>
      <Popup
        visible={props.visible}
        onHiding={() => props.changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title={props.id ? 'Редактирование корректировки' : 'Создание корректировки'}
        width={1000}
        onShowing={onShown}
        onHidden={onHiden}
        height="auto"
      >
        <div className="modal-block">
          <form onSubmit={handleSubmit}>
            <div className="modal-block__content">
              <ValidationGroup ref={validateRef}>
                <Form formData={form} ref={formSubmit}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <div className="d-flex">
                      <div style={{ width: 600 }}>
                        <AppFieldBox label="Транспорт" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите транспорт"
                            mode="text"
                            value={form.transportId}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, transportId: e }));
                            }}
                            searchMode="contains"
                            searchExpr="fullName"
                            searchEnabled
                            displayExpr="fullName"
                            valueExpr="id"
                            //dataSource={storeTransport.data.map((i: any) => i.id > 0)}
                            dataSource={storeTransport}
                          >
                            <Validator>
                              <RequiredRule message="Выберите транспорт" />
                            </Validator>
                          </SelectBox>
                        </AppFieldBox>
                        <AppFieldBox label="Водитель" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите водителя"
                            mode="text"
                            value={form.driverId}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, driverId: e }));
                            }}
                            searchMode="contains"
                            searchExpr="fullName"
                            searchEnabled
                            displayExpr="fullName"
                            valueExpr="id"
                            dataSource={storeEmployee}
                          ></SelectBox>
                        </AppFieldBox>

                        <AppFieldBox label="Объём на печать (куб.)" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="Объём на печать"
                            //mode="text"
                            format="###0.##"
                            value={form.printQuantity}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, printQuantity: e.value }));
                            }}
                            min={0.5}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Объём на печать" />
                            </Validator>
                          </NumberBox>
                        </AppFieldBox>

                        <AppFieldBox label="Фактический объём (куб.)" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="Введите фактический объём"
                            //mode="text"
                            format="###0.##"
                            value={form.quantity}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, quantity: e.value }));
                            }}
                            min={0.5}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Объём" />
                            </Validator>
                          </NumberBox>
                        </AppFieldBox>

                        <AppFieldBox label="Метод приёма" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            placeholder="Выберите метод приёма"
                            mode="text"
                            value={form.methodOfReceptionId}
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, methodOfReceptionId: e }));
                            }}
                            searchMode="contains"
                            searchExpr="displayName"
                            searchEnabled
                            displayExpr="displayName"
                            valueExpr="id"
                            //dataSource={storeTransport.data.map((i: any) => i.id > 0)}
                            dataSource={methodOfReceptionList}
                          >
                            <Validator>
                              <RequiredRule message="Выберите метод приёма" />
                            </Validator>
                          </SelectBox>
                        </AppFieldBox>

                        <AppFieldBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Комментарий"
                            mode="text"
                            value={form.comment}
                            onValueChange={(e: any) => {
                              setForm((prev: any) => ({ ...prev, comment: e }));
                            }}
                          ></TextArea>
                        </AppFieldBox>
                      </div>
                      <div style={{ width: 400 }}>
                        <table className="tableMaterialAdjustment">
                          <thead>
                            <tr>
                              <th>Материал</th>
                              <th>Объем</th>
                            </tr>
                          </thead>
                          <tbody>
                            {materials.map((item) => {
                              return (
                                <tr key={item.id}>
                                  <td>{item.name}</td>
                                  <td>
                                    <NumberBox
                                      stylingMode="underlined"
                                      placeholder="0"
                                      onValueChanged={(e) => onChangesChange(item.id!, e.value)}
                                      value={stateAdjustment[item.id!]}
                                    />
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <ModalFooter
                      useSubmitBehavior={false}
                      handleSubmit={handleSubmit}
                      hideModal={() => props.changeVisible(false)}
                      disabledSubmit={disabledSubmit}
                    />
                  </Item>
                </Form>
              </ValidationGroup>
            </div>
          </form>
        </div>
      </Popup>
    </div>
  );
};

export default AdjustmentCreateWorkRequestModal;
